<template>
  <div class="container-fluid">
    <div class="row project-cards">
      <Screen ref="tableRef" />
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import Screen from "./components/ScreenCreate.vue";

const emit = defineEmits(["formCreated"]);

function reloadTable() {
  if (tableRef.value && typeof tableRef.value.loadItems === 'function') {
    tableRef.value.loadItems();
  }
}
</script>